export const DOCRenewSubscriptionPricingFormName =
  'doc-renew-subscription-pricing';

export enum DOCRenewSubscriptionPricingFormFields {
  TransferAllEligibleMemberships = 'transferAllEligibleMemberships',
  PackageOptions = 'packageOptions',
}
